var _a, _b;
import { createActions } from 'redux-actions';
export var ADD_VOUCHER = 'ADD_VOUCHER';
export var REMOVE_VOUCHER = 'REMOVE_VOUCHER';
export var SET_VOUCHER = 'SET_VOUCHER';
export var removeVoucher = (_b = createActions((_a = {},
    _a[REMOVE_VOUCHER] = function () { },
    _a[SET_VOUCHER] = function (voucher) { return voucher; },
    _a)), _b.removeVoucher), setVoucher = _b.setVoucher;
